/**
 * Created by daniel.plotkin on 08/08/2018.
 */
import {
  Component,
  Input,
  Output,
  ElementRef, EventEmitter
} from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'expansion-panel',
  providers: [],
  viewProviders: [],
  animations: [
    trigger('expandAnimation', [
      state('void', style({
        'opacity': '1',
        'height': '0'
      })),
      // transition('* => *', animate(500))
      transition('* => void', [
        style({height: '!', opacity: 1}),
        animate('{{animationDuration}}', style({height: 0, opacity: 1}))
      ]),
      transition('void => *', [
        style({height: 0, opacity: 1}),
        animate('{{animationDuration}}', style({height: '*', opacity: 1}))
      ])
    ])
  ],
  templateUrl: './expansion-panel.html',
  // styles: ['.cds-expansion-panel {box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12); overflow: hidden;} ' +
  // '.expansion-panel-header { width: 100%;}' +
  // '.expansion-panel-title {display: inline-block;}']
  styles: ['.cds-expansion-panel {overflow: hidden;} ' +
  '.expansion-panel-header {width: 100%;}' +
  '.expansion-panel-title {display: inline-block;}']
})

export class ExpansionPanelComponent {
  @Input() expanded: boolean = false;
  @Input() hideToggle: boolean;
  @Input() title: string;
  @Input() animationDuration: string;

  open() {
    this.expanded = !this.expanded;
  }
}
